export const variables = {
  page: document.querySelector("#page"),
  header: document.querySelector("#header"),
  footer: document.querySelector(".footer"),
  body: document.querySelector("body"),
};
